import type {
	ParametricListValue,
	ParametricListValuewithCount,
	Product,
	VariantParametric
} from "@nwt/norce-pwa/dist/runtime/types/api/product/product";

interface FindVariantImageParams {
	product: Product;
	color: ParametricListValue | ParametricListValuewithCount;
	selectedSecondParametric?: ParametricListValue;
}

/**
 * Pure function to find variant image key matching color and optional second parametric
 */
export const variantImageService = {
	findVariantImageKey({
		product,
		color,
		selectedSecondParametric
	}: FindVariantImageParams): string | null {
		if (!product.Variants) {
			return null;
		}

		const matchingVariant = product.Variants.find((variant) => {
			if (
				!variant.VariantParametrics ||
				variant.VariantParametrics.length === 0
			) {
				return false;
			}

			const hasMatchingColor = variant.VariantParametrics.some(
				(param: VariantParametric) =>
					param.Code === "color" && param.ValueId === color.Id
			);

			if (!hasMatchingColor) {
				return false;
			}

			if (selectedSecondParametric) {
				return variant.VariantParametrics.some(
					(param: VariantParametric) =>
						param.Id === selectedSecondParametric.ParametricId &&
						param.ValueId === selectedSecondParametric.Id
				);
			}

			return true;
		});

		return matchingVariant?.ImageKey || null;
	}
};
